import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { fetchAllProducts } from "../api/product";
import { toast } from "react-toastify";
import { useCart } from "../context/CartContext";

const IMAGE_BASE_URL =
  process.env.REACT_APP_API_IMAGE_URL || "http://localhost:3000";

const FeaturedProducts = () => {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [product, setProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const { addToCart } = useCart();

useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetchAllProducts();
        console.log("Fetched products:", response);

        // ✅ Adjust based on your backend response structure
        const products = response.data?.data || response.data || [];

        // Group by category name
        const groupedByCategory = products.reduce((acc, product) => {
          const categoryName = product.category || "Others";
          if (!acc[categoryName]) acc[categoryName] = [];
          acc[categoryName].push(product);
          return acc;
        }, {});

        // Take first product from first 3 categories
        const selectedProducts = Object.values(groupedByCategory)
          .slice(0, 3)
          .map((categoryProducts) => categoryProducts[0]);

        setFeaturedProducts(selectedProducts);
      } catch (error) {
        console.error("Failed to load products:", error);
      }
    };

    fetchProducts();
  }, []);


  const getGradient = (index) => {
    const gradients = [
      "from-blue-900 to-blue-700", // Card 1
      "from-purple-900 to-purple-700", // Card 2
      "from-green-900 to-green-700", // Card 3
    ];
    return gradients[index % gradients.length];
  };

const handleAddToCart = (product, quantity = 1) => {
  if (
    !product ||
    product.status !== "Active" ||
    Number(product.quantity) <= 0
  ) {
    toast.warn("This product is out of stock or unavailable.");
    return;
  }
  addToCart(product, quantity);
};

  return (
    <>
    <section id="products" className="py-20 px-6  bg-gray-900/50">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-end mb-16">
          <h2 className="text-4xl font-bold text-white">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-500">
              FEATURED
            </span>{" "}
            PRODUCTS
          </h2>
          <Link to="/categories">
            <p className="text-gray-400 hover:text-cyan-400 transition cursor-pointer">
              View All →
            </p>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {featuredProducts.map((product, index) => (
            <div
              key={product._id}
              className="relative group overflow-hidden rounded-2xl bg-gradient-to-br from-gray-900 to-gray-800 border border-gray-800 hover:border-cyan-400/30 transition-all duration-500 hover:shadow-xl hover:shadow-cyan-500/10"
            >
              <div className="relative p-6">
                <div
                  className={`mb-4 aspect-square bg-gradient-to-br ${getGradient(
                    index
                  )} rounded-xl flex items-center justify-center overflow-hidden`}
                >
                  {product.image ? (
                    <img
                      src={`${IMAGE_BASE_URL}${product.image}`}
                      alt={product.name}
                      className="rounded-xl w-full h-full object-cover"
                    />
                  ) : (
                    <span className="text-4xl">🎮</span>
                  )}
                </div>

                <h3 className="text-xl font-bold text-white mb-2">
                  {product.name}
                </h3>
                <p className="text-gray-400 mb-4">
                  {product.description?.substring(0, 60)}...
                </p>

                <div className="flex justify-between items-center">
                  <span className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-purple-500">
                    ₹{Number(product.price).toLocaleString()}
                  </span>
                  <button onClick={() => handleAddToCart(product, 1)} className="px-4 py-2 bg-white/5 hover:bg-white/10 rounded-full text-sm font-medium transition border border-white/10">
                    + CART
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>    
    </>
  );
};

export default FeaturedProducts;
